import { render, staticRenderFns } from "./assignPackageSidebar.vue?vue&type=template&id=32f8c144&scoped=true&"
import script from "./assignPackageSidebar.vue?vue&type=script&lang=js&"
export * from "./assignPackageSidebar.vue?vue&type=script&lang=js&"
import style0 from "./assignPackageSidebar.vue?vue&type=style&index=0&id=32f8c144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f8c144",
  null
  
)

export default component.exports